const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args: unknown[]): void => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]): void => {
    if (isDev) console.warn(...args);
  },
  // Errors always surface regardless of environment so real failures are never silently swallowed.
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};

export default logger;
